import * as api from "../../../api/index";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  CancelOutlined,
  CheckCircleOutlined,
  KeyboardArrowLeft,
} from "@material-ui/icons";

import { ALERT, COUNTER } from "../../../constants/actionTypes";

import Profile from "../../Translator/Profile/Profile";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import "./Details.css";

const Details = ({
  quote,
  showDetails,
  setShowDetails,
  quotesLength,
  ongoing,
  verified,
  loading,
  preview,
}) => {
  dayjs.extend(relativeTime);
  const history = useHistory();
  const dispatch = useDispatch();
  const counter = useSelector((state) => state.counter);
  const [files, setFiles] = useState([]);
  const [translations, setTranslations] = useState([]);
  const [approved, setApproved] = useState([]);
  const [fetchingFiles, setFetchingFiles] = useState(true);
  const [fetchingTranslations, setFetchingTranslations] = useState(true);
  const [fetchingApproved, setFetchingApproved] = useState(true);
  const [approving, setApproving] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [profile, setProfile] = useState({});
  const [fetchingTranslator, setFetchingTranslator] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [infoType, setInfoType] = useState("");
  const [confirmAddson, setConfirmAddson] = useState(false);
  const errorMsg = quote.allocation?.declined_msg
    ? quote.allocation.declined_msg.filter((msg) => msg.quote === quote._id)
    : [];
  const disable =
    fetchingApproved || fetchingFiles || fetchingTranslations || !confirmAddson;

  const handleOpenProfile = async (email) => {
    setFetchingTranslator(true);
    try {
      setShowProfile(true);
      const { data } = await api.getUser({ email });
      setProfile(data);
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.message,
            duration: 5000,
            display: true,
          },
        });
      else
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
    } finally {
      setFetchingTranslator(false);
    }
  };

  const handleShowInfo = (type) => {
    setInfoType(type);
    setShowMessage(true);
  };

  const openModal = () => {
    document.querySelector(".details__details").open = true;
  };

  const closeModal = () => {
    document.querySelector(".details__details").open = false;
  };

  const handleApproveProject = async () => {
    setApproving(true);

    try {
      await api.updateQuote(quote.id, { status: "approved" });
      await api.updateUser(quote.creator, {
        $inc: { completedProjects: 1 },
        $pull: { "workPlace.ongoing_projects": quote.id },
      });
      approved.forEach(
        async (translator) =>
          await api.updateUser(translator.translator.id, {
            $inc: { completedProjects: 1 },
          })
      );
      await api.sendEmail({
        name: null,
        email: quote.email,
        message: `Project ${quote.projectName} has been fully translated, you can access your document from your dashboard. Do not forget to rate our service.`,
        subject: `Project ${quote.projectName} Translated`,
      });
      await api.counter({ concluded_projects: 1, verified_projects: -1 });
      dispatch({
        type: COUNTER,
        payload: {
          ...counter,
          verified_projects: counter.verified_projects - 1,
          concluded_projects: counter.concluded_projects + 1,
        },
      });
      if (quotesLength < 2) history.push("/admin/index");
      if (quotesLength > 1) setShowDetails(false);
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else {
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
      }
    }
  };

  useEffect(() => {
    const getFile = async () => {
      try {
        const file = await api.getFiles(quote.id);
        setFiles(file.data.files);
        const translation = await api.getTranslations(quote.id);
        setTranslations(translation.data.translations);
        const approved = await api.getApproved(quote.id);
        setApproved(approved.data.approved);
      } catch (error) {
        if (error.response) return false;
        else
          dispatch({
            type: ALERT,
            payload: {
              severity: "error",
              message: "An unexpected error occurred",
              duration: 5000,
              display: true,
            },
          });
      } finally {
        setFetchingTranslations(false);
        setFetchingFiles(false);
        setFetchingApproved(false);
      }
    };
    if (showDetails && quote && !loading) getFile();
  }, [showDetails, quote, preview, loading, dispatch]);

  useEffect(() => {
    if (showProfile) {
      document.getElementsByTagName("BODY")[0].style.overflow = "hidden";
    } else {
      document.getElementsByTagName("BODY")[0].style.overflow = "auto";
    }
  }, [showProfile]);

  return (
    <>
      {showProfile && (
        <Profile
          user={profile}
          loading={fetchingTranslator}
          setShowProfile={setShowProfile}
          noFxn
          admin
        />
      )}
      {loading ? (
        <div className="w-100 h-100 d-flex align-center justify-center">
          <div className="spin-large"></div>
        </div>
      ) : (
        <>
          {quote === {} ? (
            <div>No project to display</div>
          ) : (
            <>
              <div className="details position-fixed t-0 r-0 overflow-auto h-100 px-40 z-3">
                <h2
                  className="details__head d-flex align-center font-subhead py-40 pointer text-capitalise"
                  onClick={() => setShowDetails(false)}
                >
                  <KeyboardArrowLeft style={{ fontSize: "45px" }} />
                  {quote.projectName}
                </h2>
                <div className="details__scroll">
                  {ongoing && (
                    <div className="d-flex details__min__width justify-end mb-20">
                      <div
                        style={{
                          backgroundColor: quote.allocation.completed
                            ? "rgb(0, 172, 0)"
                            : "crimson",
                        }}
                        className="details__incomplete p-20 rounded box-shadow-lg mr-40"
                      >
                        {quote.allocation.completed ? (
                          <div className="d-flex w-100 h-100 align-center justify-center">
                            <CheckCircleOutlined style={{ fontSize: "36px" }} />
                            <span className="font-big font-bold pl-10">
                              Translation Completed
                            </span>
                          </div>
                        ) : (
                          <div className="d-flex w-100 h-100 align-center justify-center">
                            <CancelOutlined style={{ fontSize: "36px" }} />
                            <span className="font-big font-bold pl-10">
                              {quote.allocation.left_lang.join(", ")} not
                              Allocated
                            </span>
                          </div>
                        )}
                      </div>
                      <div
                        style={{
                          backgroundColor:
                            quote.allocation.declined === undefined ||
                            quote.allocation.declined === false
                              ? "rgb(0, 172, 0)"
                              : "crimson",
                        }}
                        className="details__declined p-20 rounded box-shadow-lg"
                      >
                        {(quote.allocation.declined === undefined ||
                          quote.allocation.declined === false) && (
                          <div className="d-flex w-100 h-100 align-center justify-center">
                            <CheckCircleOutlined style={{ fontSize: "36px" }} />
                            <span className="font-big font-bold pl-10">
                              No Declined Translation
                            </span>
                          </div>
                        )}
                        {quote.allocation.declined === true && (
                          <div className="d-flex w-100 h-100 align-center justify-center">
                            <CancelOutlined style={{ fontSize: "36px" }} />
                            <span className="font-big font-bold pl-10">
                              {quote.allocation.declined_lang.join(", ")}{" "}
                              Translation
                              {quote.allocation.declined_lang > 1
                                ? "s"
                                : ""}{" "}
                              Declined
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="details__min__width mb-40">
                    <h3 className="details__header py-5 px-40">
                      Project Details
                    </h3>
                    <div className="px-40 grid c-3">
                      <div>
                        <span className="font-bold lh-lg">Project Name: </span>
                        <span className="lh-lg pl-5">{quote.projectName}</span>
                      </div>
                      <div>
                        <span className="font-bold lh-lg">Project ID: </span>
                        <span className="lh-lg pl-5">{quote.quote_id}</span>
                      </div>
                      <div>
                        <span className="font-bold lh-lg">
                          {quote.totalPages ? "Total Pages" : "Total Words"}:{" "}
                        </span>
                        <span className="lh-lg pl-5">
                          {quote.totalPages
                            ? `${quote.totalPages} ${
                                quote.totalPages < 2 ? "" : "s"
                              }`
                            : `${quote.totalCount} words`}
                        </span>
                      </div>
                      <div>
                        <span className="font-bold lh-lg">Subject: </span>
                        <span className="lh-lg pl-5">{quote.subject}</span>
                      </div>
                      <div>
                        <span className="font-bold lh-lg">Client Email: </span>
                        <span className="lh-lg pl-5">{quote.email}</span>
                      </div>
                      <div>
                        <span className="font-bold lh-lg">Translation: </span>
                        <span className="lh-lg pl-5">
                          {quote.languageFrom} - {quote.languageTo.join(", ")}
                        </span>
                      </div>
                      <div>
                        <span className="font-bold lh-lg">Delivery Date: </span>
                        <span className="lh-lg pl-5">
                          {dayjs(quote.deliveryDate).fromNow()}
                        </span>
                      </div>
                      <div>
                        <span
                          className="admin__projects__profile font-bold lh-lg pointer"
                          onClick={() => handleShowInfo("note")}
                        >
                          Veiw Translator's Note
                        </span>
                      </div>
                      <div>
                        <span
                          className="admin__projects__profile font-bold lh-lg pointer"
                          onClick={() => handleShowInfo("decline")}
                        >
                          Veiw Decline Messages
                        </span>
                      </div>
                    </div>

                    <h3 className="details__header py-5 px-40 mt-40">
                      Project Addson
                    </h3>
                    <div className="px-40 grid c-3">
                      <div>
                        <span className="font-bold lh-lg">Notarization: </span>
                        <span className="lh-lg pl-5">
                          {quote.addson.notarization > 0 ? "Yes" : "No"}
                        </span>
                      </div>
                      <div>
                        <span className="font-bold lh-lg">Apostilles: </span>
                        <span className="lh-lg pl-5">
                          {quote.addson.apostilles > 0 ? "Yes" : "No"}
                        </span>
                      </div>
                      <div>
                        <span className="font-bold lh-lg">
                          Sworn Certificate:{" "}
                        </span>
                        <span className="lh-lg pl-5">
                          {quote.addson.sworn > 0 ? "Yes" : "No"}
                        </span>
                      </div>
                      <div>
                        <span className="font-bold lh-lg">Certified: </span>
                        <span className="lh-lg pl-5">
                          {quote.category === "General" ? "No" : "Yes"}
                        </span>
                      </div>
                    </div>

                    <h3 className="details__header py-5 px-40 mt-40">
                      Files Details
                    </h3>
                    <div className="details__row__ctn">
                      <div className="details__row__head grid c-5 my-20 px-40 py-10">
                        <span className="font-bolder">Name</span>
                        <span className="font-bolder">Type</span>
                        <span className="font-bolder">Size</span>
                        <span className="font-bolder">Quantity</span>
                      </div>
                      {fetchingFiles ? (
                        <div className="fading__ctn grid c-5">
                          <span className="fade w-100 p-20"></span>
                          <span className="fade w-100 p-20"></span>
                          <span className="fade w-100 p-20"></span>
                          <span className="fade w-100 p-20"></span>
                          <span className="fade w-100 p-20"></span>
                        </div>
                      ) : (
                        <>
                          {files.map((file, index) => (
                            <div
                              className="grid align-center c-5 px-40"
                              key={file.name.concat(index)}
                            >
                              <span className="">{file.name}</span>
                              <span className="ellipsis">{file.type}</span>
                              <span className="">
                                {file.size < 1000
                                  ? `${file.size} B`
                                  : file.size > 999999.9
                                  ? `${(file.size / 1000000).toFixed(1)} MB`
                                  : `${(file.size / 1000).toFixed(1)} KB`}
                              </span>
                              <span className="">
                                {file.count
                                  ? `${file.count} words`
                                  : `${
                                      file.page > 1
                                        ? `${file.page} pages`
                                        : `${file.page} page`
                                    }`}
                              </span>
                              <a
                                download={`${file.name}(${quote.projectName})-NT`}
                                href={file.base64}
                              >
                                <button className="outline-0 border-0 font-bold font-normal rounded p-10 w-100">
                                  Preview
                                </button>
                              </a>
                            </div>
                          ))}
                        </>
                      )}
                    </div>

                    <h3 className="details__header py-5 px-40 mt-40">
                      Payment Information
                    </h3>
                    <div className="px-40 grid c-3">
                      <div>
                        <span className="font-bold lh-lg">Category: </span>
                        <span className="lh-lg pl-5">Advance</span>
                      </div>
                      <div>
                        <span className="font-bold lh-lg">Unit Price: </span>
                        <span className="lh-lg pl-5">$44.99</span>
                      </div>
                      <div>
                        <span className="font-bold lh-lg">Paid: </span>
                        <span className="lh-lg pl-5">$4499.00</span>
                      </div>
                      <div>
                        <span className="font-bold lh-lg">Method: </span>
                        <span className="lh-lg pl-5">Paypal</span>
                      </div>
                      <div>
                        <span className="font-bold lh-lg">Date: </span>
                        <span className="lh-lg pl-5">20-10-2020</span>
                      </div>
                      <div>
                        <span className="font-bold lh-lg">Email: </span>
                        <span className="lh-lg pl-5">payment@email.com</span>
                      </div>
                    </div>

                    <h3 className="details__header py-5 px-40 mt-40">
                      Contributors Information
                    </h3>
                    <div className="details__row__ctn">
                      <div className="details__row__head grid c-5 my-20 px-40 py-10">
                        <span className="font-bolder">Translator</span>
                        <span className="font-bolder">Language</span>
                        <span className="font-bolder">Alocated on</span>
                        <span className="font-bolder">Review Date</span>
                        <span className="font-bolder">To pay</span>
                      </div>
                      {quote.contributors.length < 1 ? (
                        <div className="w-100 text-center font-bold">
                          No Active Contributor
                        </div>
                      ) : (
                        <>
                          {quote.contributors.map((contributor, index) => (
                            <div
                              className="grid align-center c-5 px-40"
                              key={contributor.translator.name.concat(index)}
                            >
                              <span
                                className="admin__projects__profile pointer"
                                onClick={() =>
                                  handleOpenProfile(
                                    contributor.translator.email
                                  )
                                }
                              >
                                {contributor.translator.name}
                              </span>
                              <span className="">{contributor.language}</span>
                              <span className="">
                                {dayjs(contributor.createdAt).format(
                                  "MM-DD-YYYY"
                                )}
                              </span>
                              <span className="">
                                {dayjs(contributor.reviewDate).format(
                                  "MM-DD-YYYY"
                                )}
                              </span>
                              <span className="">
                                ${contributor.amount.toFixed(2)}
                              </span>
                            </div>
                          ))}
                        </>
                      )}
                    </div>

                    <h3 className="details__header py-5 px-40 mt-40">
                      Translation Information
                    </h3>
                    <div className="details__row__ctn">
                      <div className="details__row__head grid c-5 my-20 px-40 py-10">
                        <span className="font-bolder">Translator</span>
                        <span className="font-bolder">Language</span>
                        <span className="font-bolder">Size</span>
                        <span className="font-bolder">Type</span>
                      </div>
                      {fetchingTranslations ? (
                        <div className="fading__ctn grid c-5">
                          <span className="fade w-100 p-20"></span>
                          <span className="fade w-100 p-20"></span>
                          <span className="fade w-100 p-20"></span>
                          <span className="fade w-100 p-20"></span>
                          <span className="fade w-100 p-20"></span>
                        </div>
                      ) : (
                        <>
                          {translations.length < 1 ? (
                            <div className="w-100 text-center font-bold">
                              No Translation Available
                            </div>
                          ) : (
                            <>
                              {translations.map((translation, index) => (
                                <div key={translation.language.concat(index)}>
                                  {translation.files.map((file, i) => (
                                    <div
                                      className="grid align-center c-5 px-40"
                                      key={file.name.concat(i)}
                                    >
                                      <span
                                        className="admin__projects__profile pointer"
                                        onClick={() =>
                                          handleOpenProfile(
                                            translation.translator.email
                                          )
                                        }
                                      >
                                        {translation.translator.name}
                                      </span>
                                      <span className="">
                                        {translation.language}
                                      </span>
                                      <span>
                                        {file.size < 1000
                                          ? `${file.size} B`
                                          : file.size > 999999.9
                                          ? `${(file.size / 1000000).toFixed(
                                              1
                                            )} MB`
                                          : `${(file.size / 1000).toFixed(
                                              1
                                            )} KB`}
                                      </span>
                                      <span className="">{file.type}</span>
                                      <a
                                        download={`${file.name}(${quote.projectName})-NT`}
                                        href={file.base64}
                                      >
                                        <button className="outline-0 border-0 font-bold font-normal rounded p-10 w-100">
                                          Preview
                                        </button>
                                      </a>
                                    </div>
                                  ))}
                                </div>
                              ))}
                            </>
                          )}
                        </>
                      )}
                    </div>

                    <h3 className="details__header py-5 px-40 mt-40">
                      Approved Translation
                    </h3>
                    <div className="details__row__ctn">
                      <div className="details__row__head grid c-5 my-20 px-40 py-10">
                        <span className="font-bolder">Translator</span>
                        <span className="font-bolder">Language</span>
                        <span className="font-bolder">Size</span>
                        <span className="font-bolder">Type</span>
                      </div>
                      {fetchingApproved ? (
                        <div className="fading__ctn grid c-5">
                          <span className="fade w-100 p-20"></span>
                          <span className="fade w-100 p-20"></span>
                          <span className="fade w-100 p-20"></span>
                          <span className="fade w-100 p-20"></span>
                          <span className="fade w-100 p-20"></span>
                        </div>
                      ) : (
                        <>
                          {approved.length < 1 ? (
                            <div className="w-100 text-center font-bold">
                              No Approved Translation
                            </div>
                          ) : (
                            <>
                              {approved.map((translation, index) => (
                                <div key={translation.language.concat(index)}>
                                  {translation.files.map((file, i) => (
                                    <div
                                      className="grid align-center c-5 px-40"
                                      key={file.name.concat(i)}
                                    >
                                      <span
                                        className="admin__projects__profile pointer"
                                        onClick={() =>
                                          handleOpenProfile(
                                            translation.translator.email
                                          )
                                        }
                                      >
                                        {translation.translator.name}
                                      </span>
                                      <span className="">
                                        {translation.language}
                                      </span>
                                      <span>
                                        {file.size < 1000
                                          ? `${file.size} B`
                                          : file.size > 999999.9
                                          ? `${(file.size / 1000000).toFixed(
                                              1
                                            )} MB`
                                          : `${(file.size / 1000).toFixed(
                                              1
                                            )} KB`}
                                      </span>
                                      <span className="">{file.type}</span>
                                      <a
                                        download={`${file.name}(${quote.projectName})-NT`}
                                        href={file.base64}
                                      >
                                        <button className="outline-0 border-0 font-bold font-normal rounded p-10 w-100">
                                          Preview
                                        </button>
                                      </a>
                                    </div>
                                  ))}
                                </div>
                              ))}
                            </>
                          )}
                        </>
                      )}
                    </div>
                    {verified && (
                      <>
                        <h3 className="details__header py-5 px-40 mt-40">
                          Addson Confirmation
                        </h3>
                        <div className="px-40 py-20">
                          <label className="d-flex align-center">
                            <input
                              type="checkbox"
                              value={confirmAddson}
                              style={{ width: "20px", height: "20px" }}
                              onChange={(e) =>
                                setConfirmAddson(e.target.checked)
                              }
                            />
                            <span className="ml-20 font-bold font-bigger">
                              Please confirm that all addson have been
                              implemented!
                            </span>
                          </label>
                        </div>
                      </>
                    )}
                  </div>
                  {verified && (
                    <div className="d-flex justify-center my-40 py-20">
                      <button
                        style={{
                          backgroundColor: "rgb(0, 172, 0)",
                          opacity: disable ? "0.6" : "",
                        }}
                        className="text-uppercase border-0 outline-0 w-75 p-10 font-big font-bold rounded"
                        disabled={disable}
                        onClick={openModal}
                      >
                        APPROVE PROJECT {quote.projectName}
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div
                style={{ right: showMessage ? 0 : "" }}
                className="details__declined__msg position-fixed h-100 t-0 z-4 overflow-auto"
              >
                <h3
                  className="position-sticky d-flex align-center p-20 pointer border-bottom-1 t-0"
                  onClick={() => setShowMessage(false)}
                >
                  <KeyboardArrowLeft style={{ fontSize: "36px" }} />
                  {infoType === "decline" && "Decline Message"}
                  {infoType === "note" && "Note"}
                </h3>
                {infoType === "decline" && (
                  <>
                    {errorMsg < 1 ? (
                      <div className="font-bold text-center py-20 font-big">
                        No message
                      </div>
                    ) : (
                      errorMsg.map((msg) => (
                        <div
                          className="d-flex flex-column px-20 py-10 border-bottom-1"
                          key={msg.message}
                        >
                          <span className="font-bold font-big">
                            {msg.translator}
                          </span>
                          <span className="lh-lg">{msg.message}</span>
                          <time className="font-sm font-bolder text-right">
                            {dayjs(msg.createdAt).fromNow()}
                          </time>
                        </div>
                      ))
                    )}
                  </>
                )}
                {infoType === "note" && (
                  <div className="d-flex flex-column px-20 py-10">
                    {quote.translatorNote === "" ? (
                      <span className="font-bold font-big py-20 text-center">
                        No Note
                      </span>
                    ) : (
                      <span className="lh-lg">{quote.translatorNote}</span>
                    )}
                  </div>
                )}
              </div>
              {verified && (
                <details
                  style={{ backgroundColor: "red" }}
                  className="details__details"
                >
                  <summary className="list-none"></summary>
                  <div className="d-flex align-center justify-center position-fixed t-0 r-0 w-100 h-100 z-5">
                    <div className="d-flex flex-column align-center text-center p-20">
                      {
                        <h3 className="font-subhead">
                          Approve Project {quote.projectName}
                        </h3>
                      }
                      <p className="text-center font-heavy font-big py-40">
                        Once Project {quote.projectName} is approved, it becomes
                        available to the clients.
                        <br />
                        <strong>Vet before approval!</strong>
                      </p>
                      <div className="d-flex justify-between">
                        <button
                          className="details__btn__cancel border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                          onClick={closeModal}
                          disabled={approving || !confirmAddson}
                        >
                          Cancel
                        </button>
                        {
                          <button
                            style={{
                              opacity: disable || approving ? "0.6" : "",
                            }}
                            className="details__btn__assign d-flex justify-center align-center border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                            disabled={disable || approving}
                            onClick={handleApproveProject}
                          >
                            Approve
                            {approving && (
                              <div className="spin-white ml-10"></div>
                            )}
                          </button>
                        }
                      </div>
                    </div>
                  </div>
                </details>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default Details;
